module.exports = __webpack_public_path__ + "img/unmailed-statements-empty.3a1a1e7d.png";